import { ChangeDetectionStrategy, Component } from "@angular/core";
import { CommonModule } from "@angular/common";
import { RouterModule } from "@angular/router";
import { LanguageService } from "../../services/language/language.service";

interface HeroMetric {
  value: string;
  labelKey: string;
}

interface MockSignal {
  labelKey: string;
  value: string;
  detailKey?: string;
  trend?: "up" | "down";
  delta?: string;
}

interface PublicFeature {
  icon: string;
  titleKey: string;
  descriptionKey: string;
}

interface PlanHighlight {
  titleKey: string;
  descriptionKey: string;
}

@Component({
  selector: "app-home-public",
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: "./home-public.component.html",
  styleUrls: ["./home-public.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HomePublicComponent {
  readonly heroMetrics: ReadonlyArray<HeroMetric> = [
    { value: "1.2M", labelKey: "homePublic.hero.metrics.documents" },
    { value: "42 ms", labelKey: "homePublic.hero.metrics.latency" },
    { value: "99.2%", labelKey: "homePublic.hero.metrics.compliance" }
  ];

  readonly mockSignals: ReadonlyArray<MockSignal> = [
    {
      labelKey: "homePublic.mock.cards.documents.label",
      value: "128",
      detailKey: "homePublic.mock.cards.documents.detail",
      trend: "up",
      delta: "+12"
    },
    {
      labelKey: "homePublic.mock.cards.repositories.label",
      value: "14",
      detailKey: "homePublic.mock.cards.repositories.detail"
    },
    {
      labelKey: "homePublic.mock.cards.users.label",
      value: "32",
      detailKey: "homePublic.mock.cards.users.detail",
      trend: "up",
      delta: "+4"
    },
    {
      labelKey: "homePublic.mock.cards.alerts.label",
      value: "3",
      detailKey: "homePublic.mock.cards.alerts.detail",
      trend: "down",
      delta: "-2"
    }
  ];

  readonly featureList: ReadonlyArray<PublicFeature> = [
    {
      icon: "fas fa-layer-group",
      titleKey: "homePublic.features.ingestion.title",
      descriptionKey: "homePublic.features.ingestion.desc"
    },
    {
      icon: "fas fa-shield-alt",
      titleKey: "homePublic.features.security.title",
      descriptionKey: "homePublic.features.security.desc"
    },
    {
      icon: "fas fa-tachometer-alt",
      titleKey: "homePublic.features.operations.title",
      descriptionKey: "homePublic.features.operations.desc"
    }
  ];

  readonly planHighlights: ReadonlyArray<PlanHighlight> = [
    {
      titleKey: "homePublic.plan.points.speed.title",
      descriptionKey: "homePublic.plan.points.speed.desc"
    },
    {
      titleKey: "homePublic.plan.points.context.title",
      descriptionKey: "homePublic.plan.points.context.desc"
    },
    {
      titleKey: "homePublic.plan.points.support.title",
      descriptionKey: "homePublic.plan.points.support.desc"
    }
  ];

  constructor(public lang: LanguageService) {}
}
